import { render, staticRenderFns } from "./AdminUserManagement.vue?vue&type=template&id=bb5aa1f6&scoped=true"
import script from "./AdminUserManagement.vue?vue&type=script&lang=js"
export * from "./AdminUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5aa1f6",
  null
  
)

export default component.exports